import modernNormalizeCss from 'modern-normalize/modern-normalize.css?inline';
import { createGlobalStyle, css } from 'styled-components';

import { rem } from './theme';

export const SCROLLBAR_WIDTH = 5;
export const SCROLLBAR_HEIGHT = 5;

export const ScrollBarGlobalStyle = css`
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: ${rem(SCROLLBAR_WIDTH)};
    height: ${rem(SCROLLBAR_HEIGHT)};
  }
  ::-webkit-scrollbar-track {
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  ::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.25);
    transition: color 0.2s ease;
  }
`;
export const controlStyle = css`
  body {
    padding: 0;
    overflow-x: hidden;
    min-width: 320px;
    background: #fff;
    font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
    color: rgba(0, 0, 0, 0.87);
    font-smoothing: antialiased;
  }

  a {
    text-decoration: unset;
  }

  ::-webkit-selection {
    background-color: #cce2ff;
    color: rgba(0, 0, 0, 0.87);
  }
  ::-moz-selection {
    background-color: #cce2ff;
    color: rgba(0, 0, 0, 0.87);
  }
  ::selection {
    background-color: #cce2ff;
    color: rgba(0, 0, 0, 0.87);
  }
  input::-webkit-selection,
  textarea::-webkit-selection {
    background-color: rgba(100, 100, 100, 0.4);
    color: rgba(0, 0, 0, 0.87);
  }
  input::-moz-selection,
  textarea::-moz-selection {
    background-color: rgba(100, 100, 100, 0.4);
    color: rgba(0, 0, 0, 0.87);
  }
  input::selection,
  textarea::selection {
    background-color: rgba(100, 100, 100, 0.4);
    color: rgba(0, 0, 0, 0.87);
  }
  body ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
  }
  body ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 0;
  }
  body ::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.25);
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
  }
  body ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(0, 0, 0, 0.15);
  }
  body ::-webkit-scrollbar-thumb:hover {
    background: rgba(128, 135, 139, 0.8);
  }
`;

interface GlobalStyleArgs {
  myAccount?: boolean;
  control?: boolean;
  isNewUiEnabled?: boolean;
  $isDarkModeEnabled?: boolean;
}

export const GlobalStyle = createGlobalStyle<GlobalStyleArgs>`
  :root {
    font-size: 14px;
  }
  
  ${modernNormalizeCss};

  ${({ myAccount }) => (myAccount ? ScrollBarGlobalStyle : controlStyle)}
  
  h1,
  h2,
  h3,
  h4,
  h5,
  body {
    font-family: ${({ isNewUiEnabled }) =>
      isNewUiEnabled ? 'Inter' : 'Inter,Roboto, Arial, Helvetica, sans-serif'};
  }
  
  body {
      color: ${({ isNewUiEnabled, $isDarkModeEnabled }) => {
        if ($isDarkModeEnabled) {
          return '#ffffff';
        }

        return isNewUiEnabled ? '#000' : '#4a4a4a';
      }};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${({ myAccount, $isDarkModeEnabled }) => {
      if ($isDarkModeEnabled) {
        return '#1F1F1F';
      }

      return myAccount ? 'white' : '#F8F9FB';
    }};
    ${({ control }) => (control ? ScrollBarGlobalStyle : null)}

    ul {
        padding-inline-start: 40px;
    }
  }
  
  input:-webkit-autofill { -webkit-box-shadow: 0 0 0px 1000px #FFF inset; }
  input:-moz-autofill { -moz-box-shadow: 0 0 0px 1000px #FFF inset; }
  input:-o-autofill { -o-box-shadow: 0 0 0px 1000px #FFF inset; }
  input:-khtml-autofill { -khtml-box-shadow: 0 0 0px 1000px #FFF inset; }
`;
